import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cfb7c1fa&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./style/index.scss?vue&type=style&index=0&id=cfb7c1fa&lang=scss&scoped=true&"
import style1 from "../reset/style/stepDialog.scss?vue&type=style&index=1&lang=scss&"
import style2 from "./index.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb7c1fa",
  null
  
)

export default component.exports